function Text1Component() {
	return (
		<div className='text1Component'>
			<p>
				Hello, my name is Adi Bader, <br />I am a creative front-end developer
				from Israel. I have a passion for combining between my coding skills and
				my strong design orientation, to create beautiful and efficient web
				apps. <br />I build this site in order to expose my abilities to the
				world and to find a decent job as a front end developer.
			</p>
		</div>
	);
}

export default Text1Component;
